import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={22.905}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 13804 15489"
    {...props}
  >
    <defs>
      <style>
        {/* {".{stroke:#2b2a29;stroke-width:401.802}.fil1{fill:#1c1b17}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974347732208">
        <path
          d="M9043 13111v-1840c1659-816 2725-2519 2725-4368 0-2684-2183-4867-4867-4867-2682 0-4865 2183-4865 4867 0 1850 1067 3553 2727 4368v1840C2106 12199 337 9732 337 6903c0-3621 2945-6566 6564-6566 3621 0 6566 2945 6566 6566 0 2830-1768 5296-4424 6208zm-337 281c-1167 325-2438 325-3607 0v-2153c1150 476 2435 490 3607-1v2154zm-593 1589c0 95-77 171-171 171-95 0-171-76-171-171v-1062c114-14 228-31 342-50v1112zm-2081 0c0 95-77 171-171 171s-171-76-171-171v-1112c114 19 228 36 342 49v1063zm2992-4080c-44-86-144-113-223-75-1229 595-2608 574-3797 1-79-37-178-10-222 75-1471-782-2409-2325-2409-3999 0-2498 2031-4530 4528-4530 2498 0 4530 2032 4530 4530 0 1672-937 3215-2407 3998zM6901 0C3096 0 0 3096 0 6903c0 3090 2020 5666 4763 6561v55c0 74 48 140 120 161 155 47 312 87 470 123v1178c0 280 228 508 508 508s508-228 508-508v-1029c360 27 705 27 1065 0v1029c0 280 228 508 508 508s507-228 507-508v-1178c160-36 318-77 474-124 71-21 120-87 120-161v-54c2739-894 4761-3468 4761-6561C13804 3096 10707 0 6901 0z"
          style={{
            fill: "#2b2a29",
          }}
          className="fill"
        />
        <circle cx={6902} cy={1238} r={342} className="fil1" />
        <circle
          r={439}
          className="fil1 "
          transform="scale(.7776) rotate(-20 8954.057 -16005.69)"
        />
        <circle
          r={439}
          className="fil1"
          transform="scale(.7776) rotate(-40 6772.252 -3432.448)"
        />
        <circle
          r={439}
          className="fil1"
          transform="scale(.7776) rotate(-60 6014.527 934.203)"
        />
        <circle
          r={439}
          className="fil1"
          transform="scale(.7776) rotate(-80 5679.882 3297.216)"
        />
        <circle
          r={439}
          className="fil1"
          transform="scale(-.7776) rotate(80 5671.976 -6743.874)"
        />
        <circle
          r={439}
          className="fil1"
          transform="scale(-.7776) rotate(60 10278.974 -9904.943)"
        />
        <circle
          r={439}
          className="fil1"
          transform="scale(-.7776) rotate(40 18682.963 -14896.796)"
        />
        <circle
          r={439}
          className="fil1 "
          transform="scale(.7776) rotate(20 -78.173 34331.888)"
        />
        <circle
          r={439}
          className="fil1 "
          transform="scale(.7776) rotate(40 2103.655 20953.9)"
        />
        <circle
          r={439}
          className="fil1 "
          transform="scale(.7776) rotate(60 2765.78 16342.488)"
        />
        <circle
          r={439}
          className="fil1 "
          transform="scale(.7776) rotate(80 3049.537 13928.402)"
        />
        <circle
          r={439}
          className="fil1 "
          transform="scale(-.7776) rotate(-80 -14625.829 3619.935)"
        />
        <circle
          r={439}
          className="fil1 "
          transform="scale(-.7776) rotate(-60 -19176.414 5514.863)"
        />
        <circle
          r={439}
          className="fil1 "
          transform="scale(-.7776) rotate(-40 -27527.407 9421.797)"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
